// src/widgets/moderation/KpiCards/KpiCards.tsx
import React from 'react';
import { Card } from '../Card/Card';
import './KpiCards.scss';

export type KpiCardItem = {
  key: string; // e.g. "new"
  label: string;
  value: number;
  hint?: string;
};

type Props = {
  items: KpiCardItem[];
  onClick?: (key: string) => void;
};

export const KpiCards: React.FC<Props> = ({ items, onClick }) => {
  return (
    <div className="md-kpis">
      {items.map((item) => (
        <button
          key={item.key}
          className="md-kpis__item"
          type="button"
          onClick={() => onClick?.(item.key)}
        >
          <Card className="md-kpis__card">
            <div className="md-kpis__label">{item.label}</div>
            <div className="md-kpis__value">{item.value}</div>
            {item.hint && <div className="md-kpis__hint">{item.hint}</div>}
          </Card>
        </button>
      ))}
    </div>
  );
};
